@if (showPrevButton() && displaySliderButtons()) {
  <div class="td-wb-slider__control td-wb-slider__control--previous"
       [class.td-wb-slider__control--hide-fade]="removeFade()">
    <div class="td-wb-slider__button td-wb-slider__button--previous"
         [class.td-wb-slider__button--hide-fade]="removeFade()">
      <button tdWbIconButton
              tdWbIconButtonBackground="elevation"
              tdWbIconButtonSize="regular"
              id="sliderPreviousButton"
              (click)="previous()"
              [attr.aria-label]="'tdWb.slider.PREVIOUS' | tdWbTranslate">
        <td-wb-icon size="18"
                    iconId="caret-left--small" />
      </button>
    </div>
  </div>
}
<div tdWbScrollable class="td-wb-slider__container" [attr.aria-labelledby]="ariaLabelledby()" [tabbable]="tabbable()">
  <ng-content />
</div>
@if (showNextButton() && displaySliderButtons()) {
  <div class="td-wb-slider__control td-wb-slider__control--next"
       [class.td-wb-slider__control--hide-fade]="removeFade()">
    <div class="td-wb-slider__button td-wb-slider__button--next"
         [class.td-wb-slider__button--hide-fade]="removeFade()">
      <button tdWbIconButton
              tdWbIconButtonBackground="elevation"
              tdWbIconButtonSize="regular"
              id="sliderNextButton"
              (click)="next()"
              [attr.aria-label]="'tdWb.slider.NEXT' | tdWbTranslate">
        <td-wb-icon size="18"
                    iconId="caret-right--small" />
      </button>
    </div>
  </div>
}
